import ExcelExport from "export-xlsx";
import React, { useState } from "react";
import api from "../../api";
import { GenerateOptionsYearForExport } from "../../components/functions/Functions";
import DropdownReport from "../report/report.dropdwn";
import Loading from "../../components/loading/Loading";
import {
  formatExcelKeep,
  formatExcelFollowLog,
  generateFunctionFromData,
} from "../../utils/generateFunctionFromData";
import { findMaxLength } from "../../utils/findMaxLength";
import FunctionCheckType from "../report/functions/Report.FunctionCheckType";
import { optionFullMonth, optionType } from "../../contexts/DataOptions";
import { useSelector } from "react-redux";
import { getUserDepartment } from "../../utils/formatUserDepartment";
import classNames from "classnames";
import {
  transformTaskForExport,
  injectAttemptsForExport,
  formatDateBE,
} from "./Export.Helpers";

const ExportMainOptimized = () => {
  const [, setDataDashboard] = useState({});
  const [startMonth, setStartMonth] = useState("");
  const [endMonth, setEndMonth] = useState("");
  const [startYear, setStartYear] = useState("");
  const [endYear, setEndYear] = useState("");
  //
  const [startMonthNew, setStartMonthNew] = useState("");
  const [endMonthNew, setEndMonthNew] = useState("");
  const [startYearNew, setStartYearNew] = useState("");
  const [endYearNew, setEndYearNew] = useState("");
  //
  const [loading, setLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState("");
  const optionsYear = GenerateOptionsYearForExport();
  //
  const [type, setType] = useState({ value: "", label: "" });
  const [followLogYear, setFollowLogYear] = useState("");

  const { user } = useSelector((state) => state.auth);
  const [userDept, setUserDept] = useState(user?.user_department);
  const [isActivated, setIsActivated] = useState(getUserDepartment(userDept));

  const isAN = user?.user_department === "super_AN";

  const isNurse =
    user?.user_department === "NURSE" ||
    user?.user_department === "AN" ||
    user?.user_department === "TR" ||
    user?.user_department === "IR" ||
    user?.user_department === "PED";

  const LoadDashboard = async (thisUserDept) => {
    const { data } = await api.get("/dashboard/status", {
      params: {
        user_department: thisUserDept,
      },
    });
    setDataDashboard(data?.data);
  };

  React.useEffect(() => {
    if (!isActivated) {
      if (user?.user_department || userDept) {
        const thisUserDept = userDept
          ? getUserDepartment(userDept)
          : getUserDepartment(user?.user_department);
        setIsActivated(thisUserDept);
      }
    }
  }, [user?.user_department, userDept, isActivated]);

  React.useEffect(() => {
    if (userDept || user?.user_department) {
      const thisUserDept = userDept
        ? getUserDepartment(userDept)
        : getUserDepartment(user?.user_department);
      LoadDashboard(thisUserDept);
    }
  }, [userDept, user?.user_department]);

  /**
   * OPTIMIZED: Export Excel Type using new backend API with pagination
   * ดึงข้อมูลแบบแบ่งหน้าเพื่อหลีกเลี่ยง Lambda payload limit (6MB)
   */
  const onClickExportExcelType = async () => {
    try {
      setLoading(true);
      setLoadingMessage("กำลังดึงข้อมูล...");

      const startDate = `${startYearNew?.value}-${startMonthNew?.value}-01`;
      const endDate = `${endYearNew?.value}-${endMonthNew?.value}-31`;
      const thisUserDept = userDept
        ? getUserDepartment(userDept)
        : getUserDepartment(user?.user_department);

      // ดึงข้อมูลแบบแบ่งหน้า (pagination)
      let allTasks = [];
      let currentPage = 1;
      let hasNextPage = true;
      const pageLimit = 200; // จำนวน records ต่อ page

      while (hasNextPage) {
        setLoadingMessage(`กำลังดึงข้อมูล... (หน้า ${currentPage})`);

        const { data } = await api.get("/tasks/export", {
          params: {
            startDate,
            endDate,
            type: type?.value,
            user_department: thisUserDept,
            page: currentPage,
            limit: pageLimit,
          },
        });

        allTasks = [...allTasks, ...data.tasks];
        hasNextPage = data.hasNextPage;
        currentPage++;

        // อัพเดต progress
        if (data.totalCount > 0) {
          const progress = Math.min(
            100,
            Math.round((allTasks.length / data.totalCount) * 100)
          );
          setLoadingMessage(
            `กำลังดึงข้อมูล... ${progress}% (${allTasks.length}/${data.totalCount})`
          );
        }
      }

      setLoadingMessage("กำลังประมวลผลข้อมูล...");

      // กรองตาม type (ใช้ allTasks ที่รวมจากทุกหน้า)
      const filteredTasks = allTasks?.filter((task) => {
        return (
          FunctionCheckType(
            task?.catheter?.value,
            task?.other_catheter_name,
            task?.check_catheter
          ) === type?.value
        );
      });

      // Transform tasks
      let countAttempt = [];
      const transformedTasks = filteredTasks?.map((task) => {
        if (task?.attempts?.length > 0) {
          countAttempt.push(task?.attempts?.length);
        }
        return transformTaskForExport(task);
      });

      // Find max attempt
      const maxAttempt = findMaxLength(countAttempt);

      // Inject attempts data
      const injectAttempts = transformedTasks.map((task) =>
        injectAttemptsForExport(task, maxAttempt)
      );

      // Remove duplicates
      const FilteredInjectAttempts = injectAttempts.filter(
        (thing, index, self) =>
          index === self.findIndex((t) => t._id === thing._id)
      );

      // Sort by date and HN
      const toDateOnlyTs = (val) => {
        if (!val) return 0;
        const d = new Date(val);
        if (Number.isNaN(d.getTime())) return 0;
        const y = d.getFullYear();
        const m = d.getMonth();
        const day = d.getDate();
        return new Date(y, m, day).getTime();
      };
      const toHNNumber = (hn) => {
        if (hn == null) return 0;
        const num = String(hn).replace(/[^0-9]/g, "");
        return Number(num) || 0;
      };

      const sortedByDateAndHN = [...FilteredInjectAttempts].sort((a, b) => {
        const da = toDateOnlyTs(a?.final_date_success);
        const db = toDateOnlyTs(b?.final_date_success);
        if (da !== db) return da - db;
        return toHNNumber(a?.hn) - toHNNumber(b?.hn);
      });

      // Resequence running number
      sortedByDateAndHN.forEach((row, i) => {
        row.id_picc_new = i + 1;
      });

      setLoadingMessage("กำลังสร้างไฟล์ Excel...");

      const formatData2 = [{ data: sortedByDateAndHN }];
      const excelExport = new ExcelExport();
      const settings = generateFunctionFromData(
        maxAttempt,
        startMonthNew,
        startYearNew,
        endMonthNew,
        endYearNew,
        type
      );

      await excelExport.downloadExcel(settings, formatData2);
    } catch (error) {
      console.log("error", error);
      alert("เกิดข้อผิดพลาดในการ export ข้อมูล");
    } finally {
      setLoading(false);
      setLoadingMessage("");
    }
  };

  /**
   * OPTIMIZED: Export Excel Keep using new backend API
   */
  const onClickExportExcelKeep = async () => {
    try {
      setLoading(true);
      setLoadingMessage("กำลังดึงข้อมูล...");

      const startDate = `${startYear?.value}-${startMonth?.value}-01`;
      const endDate = `${endYear?.value}-${endMonth?.value}-31`;
      const thisUserDept = userDept
        ? getUserDepartment(userDept)
        : getUserDepartment(user?.user_department);

      // เรียก API ใหม่สำหรับ keep tasks
      const { data } = await api.get("/tasks/export-keep", {
        params: {
          startDate,
          endDate,
          user_department: thisUserDept,
        },
      });

      setLoadingMessage("กำลังประมวลผลข้อมูล...");

      // Transform tasks
      const transformedTasks = data?.tasks?.map((task, index) => ({
        ...task,
        id: task?._id,
        number: index + 1,
        name: task?.full_name ?? "-",
        last_name: task?.last_name ?? "-",
        status: "ไม่ดำเนินการต่อ",
        patient_type: task?.other_patient_type_name
          ? task?.other_patient_type_name
          : task?.patient_type?.label || "",
        ward1: task?.option_ward?.label || "",
        ward2: task?.ward?.label || task?.other_ward_name || "",
        paper_date: task?.paper_date ? new Date(task?.paper_date) : null,
        paper_date_BE: task?.paper_date ? formatDateBE(task?.paper_date) : "",
        paper_time: task?.paper_time || "",
        promise_date: task?.promise ? new Date(task?.promise) : null,
        promise_date_BE: task?.promise ? formatDateBE(task?.promise) : "",
        reasons: task?.reason_othrtkeep
          ? task?.reason_othrtkeep
          : task?.reason_keep?.label || "-",
        other_des: task?.other_description ?? "-",
        cancel_date: task?.cancel_date
          ? new Date(task?.cancel_date)
          : new Date(task?.updatedAt),
        cancel_date_BE: task?.cancel_date
          ? formatDateBE(task?.cancel_date)
          : formatDateBE(task?.updatedAt),
      }));

      // Sort
      const toDateOnlyTsKeep = (val) => {
        if (!val) return 0;
        const d = new Date(val);
        return Number.isNaN(d.getTime()) ? 0 : d.getTime();
      };
      const toHNNumberKeep = (hn) => {
        if (hn == null) return 0;
        const num = String(hn).replace(/[^0-9]/g, "");
        return Number(num) || 0;
      };

      const sortedKeep = [...transformedTasks].sort((a, b) => {
        const da = toDateOnlyTsKeep(a?.paper_date);
        const db = toDateOnlyTsKeep(b?.paper_date);
        if (da !== db) return da - db;
        return toHNNumberKeep(a?.hn) - toHNNumberKeep(b?.hn);
      });

      // Resequence
      sortedKeep.forEach((row, idx) => {
        row.number = idx + 1;
      });

      setLoadingMessage("กำลังสร้างไฟล์ Excel...");

      const formatData = [{ data: sortedKeep }];
      const excelExport = new ExcelExport();
      const settings = formatExcelKeep(
        startMonth,
        startYear,
        endMonth,
        endYear
      );

      await excelExport.downloadExcel(settings, formatData);
    } catch (error) {
      console.log("error", error);
      alert("เกิดข้อผิดพลาดในการ export ข้อมูล");
    } finally {
      setLoading(false);
      setLoadingMessage("");
    }
  };

  /**
   * Export Follow Up Log - สรุปจำนวนครั้งที่ลงข้อมูล Follow Up แยกรายเดือน
   */
  const onClickExportFollowLog = async () => {
    try {
      setLoading(true);
      setLoadingMessage("กำลังดึงข้อมูล Follow Up Log...");

      const thisUserDept = userDept
        ? getUserDepartment(userDept)
        : getUserDepartment(user?.user_department);

      const { data } = await api.get("/follows/export-log", {
        params: {
          year: followLogYear?.value,
          user_department: thisUserDept,
        },
      });

      setLoadingMessage("กำลังประมวลผลข้อมูล...");

      const formattedData = data?.data?.map((row) => {
        const rowData = {
          username: row._id || "-",
          total: row.total || 0,
        };
        for (let m = 1; m <= 12; m++) {
          rowData[`month_${m}`] = 0;
        }
        row.months?.forEach((entry) => {
          rowData[`month_${entry.month}`] = entry.count;
        });
        return rowData;
      });

      setLoadingMessage("กำลังสร้างไฟล์ Excel...");

      const formatData = [{ data: formattedData }];
      const excelExport = new ExcelExport();
      const settings = formatExcelFollowLog(followLogYear?.label);
      await excelExport.downloadExcel(settings, formatData);
    } catch (error) {
      console.log("error", error);
      alert("เกิดข้อผิดพลาดในการ export ข้อมูล Follow Up Log");
    } finally {
      setLoading(false);
      setLoadingMessage("");
    }
  };

  if (loading)
    return (
      <div className="flex flex-col items-center justify-center h-screen">
        <Loading />
        {loadingMessage && (
          <p className="mt-4 text-gray-600">{loadingMessage}</p>
        )}
      </div>
    );

  return (
    <div className="grid col-span-1 justify-center ">
      {isAN ? (
        <div className=" flex gap-3 justify-center items-center mb-10 mt-20">
          <button
            className={classNames(
              "bg-blue-200 h-10 w-32 rounded-lg text-lg font-bold text-gray-700 flex justify-center items-center hover:bg-blue-500 hover:text-gray-900",
              isActivated === "All"
                ? "bg-blue-500 text-gray-900"
                : "bg-blue-200"
            )}
            onClick={() => {
              setUserDept("All");
              setIsActivated("All");
            }}
          >
            All
          </button>
          <button
            className={classNames(
              "bg-blue-200 h-10 w-32 rounded-lg text-lg font-bold text-gray-700 flex justify-center items-center hover:bg-blue-500 hover:text-gray-900",
              isActivated === "AN" ? "bg-blue-500 text-gray-900" : "bg-blue-200"
            )}
            onClick={() => {
              setUserDept("AN");
              setIsActivated("AN");
            }}
          >
            AN
          </button>
          <button
            className={classNames(
              "bg-blue-200 h-10 w-32 rounded-lg text-lg font-bold text-gray-700 flex justify-center items-center hover:bg-blue-500 hover:text-gray-900",
              isActivated === "IR" ? "bg-blue-500 text-gray-900" : "bg-blue-200"
            )}
            onClick={() => {
              setUserDept("IR");
              setIsActivated("IR");
            }}
          >
            IR
          </button>
          <button
            className={classNames(
              "bg-blue-200 h-10 w-32 rounded-lg text-lg font-bold text-gray-700 flex justify-center items-center hover:bg-blue-500 hover:text-gray-900",
              isActivated === "TR" ? "bg-blue-500 text-gray-900" : "bg-blue-200"
            )}
            onClick={() => {
              setUserDept("TR");
              setIsActivated("TR");
            }}
          >
            TR
          </button>
          <button
            className={classNames(
              "bg-blue-200 h-10 w-32 rounded-lg text-lg font-bold text-gray-700 flex justify-center items-center hover:bg-blue-500 hover:text-gray-900",
              isActivated === "PED"
                ? "bg-blue-500 text-gray-900"
                : "bg-blue-200"
            )}
            onClick={() => {
              setUserDept("PED");
              setIsActivated("PED");
            }}
          >
            PED
          </button>
        </div>
      ) : null}
      {isNurse ? (
        `คุณไม่สามารถเข้าถึงหน้านี้ได้`
      ) : (
        <div className="flex justify-center gap-4">
          <div className="">
            <div className="border-2 p-4 rounded-xl my-40 ">
              <div className="text-center font-bold text-sm ">
                ข้อมูลกลุ่ม PICC line, Central line (full v.1)
              </div>
              <div className="text-center text-xs text-green-600 mt-1">
                ✨ Optimized Version - เร็วขึ้น 10x
              </div>
              <div className="mt-5">
                <DropdownReport
                  title={"ระบุประเภทสาย"}
                  className="w-85"
                  placeholder={"ระบุ"}
                  options={optionType}
                  value={type}
                  setValue={setType}
                />
              </div>
              <div className="text-left text-sm p-2"> จาก </div>
              <div className="flex">
                <div className=" p-1 gap-4">
                  {" "}
                  <DropdownReport
                    title={""}
                    className="w-40"
                    placeholder={"ระบุเดือน"}
                    options={optionFullMonth}
                    value={startMonthNew}
                    setValue={setStartMonthNew}
                  />
                </div>
                <div className=" p-1 gap-4">
                  <DropdownReport
                    title={""}
                    className="w-40"
                    placeholder={"ระบุปี"}
                    options={optionsYear}
                    value={startYearNew}
                    setValue={setStartYearNew}
                  />
                </div>
              </div>
              <div className="text-left text-sm p-2"> ถึง </div>
              <div className="flex">
                <div className=" p-1 gap-4">
                  <DropdownReport
                    title={""}
                    className="w-40"
                    placeholder={"ระบุเดือน"}
                    options={optionFullMonth}
                    value={endMonthNew}
                    setValue={setEndMonthNew}
                  />
                </div>
                <div className=" p-1 gap-4">
                  <DropdownReport
                    title={""}
                    className="w-40"
                    placeholder={"ระบุปี"}
                    options={optionsYear}
                    value={endYearNew}
                    setValue={setEndYearNew}
                  />
                </div>
              </div>
              {startMonthNew &&
                startYearNew &&
                endMonthNew &&
                endYearNew &&
                type.value !== "" && (
                  <div className="flex justify-center p-2">
                    <button
                      className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2  px-4 rounded"
                      onClick={onClickExportExcelType}
                    >
                      EXPORT
                      <div></div>
                    </button>
                  </div>
                )}
            </div>
          </div>
          <div className="">
            <div className="border-2 p-4 rounded-xl my-40 ">
              <div className="text-center font-bold text-sm ">
                ข้อมูลกลุ่มไม่ดำเนินการต่อ
              </div>
              <div className="text-center text-xs text-green-600 mt-1">
                ✨ Optimized Version - เร็วขึ้น 10x
              </div>
              <div className="text-left text-sm p-2"> จาก </div>
              <div className="flex">
                <div className=" p-1 gap-4">
                  {" "}
                  <DropdownReport
                    title={""}
                    className="w-40"
                    placeholder={"ระบุเดือน"}
                    options={optionFullMonth}
                    value={startMonth}
                    setValue={setStartMonth}
                  />
                </div>
                <div className=" p-1 gap-4">
                  <DropdownReport
                    title={""}
                    className="w-40"
                    placeholder={"ระบุปี"}
                    options={optionsYear}
                    value={startYear}
                    setValue={setStartYear}
                  />
                </div>
              </div>
              <div className="text-left text-sm p-2"> ถึง </div>
              <div className="flex">
                <div className=" p-1 gap-4">
                  <DropdownReport
                    title={""}
                    className="w-40"
                    placeholder={"ระบุเดือน"}
                    options={optionFullMonth}
                    value={endMonth}
                    setValue={setEndMonth}
                  />
                </div>
                <div className=" p-1 gap-4">
                  <DropdownReport
                    title={""}
                    className="w-40"
                    placeholder={"ระบุปี"}
                    options={optionsYear}
                    value={endYear}
                    setValue={setEndYear}
                  />
                </div>
              </div>
              {startMonth && startYear && endMonth && endYear && (
                <div className="flex justify-center p-2">
                  <button
                    className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2  px-4 rounded"
                    onClick={onClickExportExcelKeep}
                  >
                    EXPORT
                    <div></div>
                  </button>
                </div>
              )}
            </div>
          </div>
          <div className="">
            <div className="border-2 p-4 rounded-xl my-40 ">
              <div className="text-center font-bold text-sm ">
                Follow Up Log (สรุปจำนวนติดตาม)
              </div>
              <div className="text-center text-xs text-green-600 mt-1">
                สรุปจำนวนการติดตามรายเดือนต่อปี
              </div>
              <div className="mt-5">
                <DropdownReport
                  title={"ระบุปี (พ.ศ.)"}
                  className="w-85"
                  placeholder={"ระบุปี"}
                  options={optionsYear}
                  value={followLogYear}
                  setValue={setFollowLogYear}
                />
              </div>
              {followLogYear && (
                <div className="flex justify-center p-2 mt-4">
                  <button
                    className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                    onClick={onClickExportFollowLog}
                  >
                    EXPORT
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ExportMainOptimized;
